import repository from './repsitory'

const resource = '/targetDevices'

export default {
    get (type) {
        return repository.get(`${resource}`)
    },
    getActives (type) {
        return repository.get(`${resource}/active`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getTargetDevicesByTarget (targetId) {
        return repository.get(`${resource}/target/${targetId}`)
    },
    add (data) {
        return repository.post(`${resource}`, data)
    },
    update (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
